import { useEffect, useContext } from "react";
import { CountryContext } from '../Context/Country/context';
import { fetchCountries } from "../Context/Country/action";
import FeedbackForm from "./Form";
import { createFeedbackAction } from '../Context/Feedback/action';
import { DiseaseContext } from '../Context/Disease';
import { FeedBackContext } from "../Context/Feedback/context";

function Feedback() {
  const { countryState, dispatch: countryDispatch } = useContext(
    CountryContext
  );

  const { state: feedbackState, dispatch: feedbackDispatch } = useContext(FeedBackContext);


  const {
    diseaseState: { activeDisease },
  } = useContext(DiseaseContext);

  useEffect(() => {
    countryDispatch(fetchCountries());
  }, [countryDispatch]);

  const createFeedbackHandler = (values) => {
    feedbackDispatch(createFeedbackAction({
      ...values,
      disease_id: activeDisease?.disease_id
    }))
  };


  const countryOptions = countryState?.countries?.map((country) => ({
    value: country?.country_id,
    displayedValue: country?.country_name,
  }));

  return (
    <div className="bg-coolDecember min-h-full text-boudoir">
      <div className=" layout__wrapper min-h-full">
        <div className="h-3 p-4 m-4" />

        <div className="text-xl sm:text-3xl font-poppins font-bold">
          Do you have questions or feedback for us?{" "}
        </div>
        <div className="text-xl sm:text-3xl font-poppins font-bold">
          Please let us know
        </div>
        <div className="h-3 p-4 m-4" />

        <div className="sm:flex justify-between flex-wrap text-center text-sm sm:text-xs md:text-sm">
          <div className="mb-5 sm:mr-5 flex-1">
            <div className="font-semibold pb-3">Ask a question</div>
            <div className="flex justify-center items-center h-20 p-4 bg-white shadow-lg w-full">
              We would love to here from
            </div>
          </div>
          <div className="mb-5 sm:mx-4 flex-1">
            <div className="font-semibold pb-3">Request Data</div>
            <div className="flex justify-center items-center h-20 p-4 bg-white shadow-lg w-full">
              Suggest other datasets
            </div>
          </div>
          <div className="mb-5 sm:ml-5 flex-1">
            <div className="font-semibold pb-3">Report a problem</div>
            <div className="flex justify-center items-center h-20 p-4 bg-white shadow-lg w-full">
              State your complains
            </div>
          </div>
        </div>
        <div className="h-3 p-4 m-4" />
        <div className="bg-white w-full p-4 pt-6 sm:p-8">
          <div className="text-xl sm:text-3xl sm:p-6 pb-4 font-poppins font-bold">
            Contact us with this form
          </div>
          <FeedbackForm
          creatingFeedback={feedbackState?.submittingFeedback}
            createFeedbackHandler={createFeedbackHandler}
            countries={countryOptions}
          />
        </div>
        <div className="h-3 p-16" />
      </div>
    </div>
  );
}

export default Feedback;
